import React, { createContext, useContext } from "react";

const CompanyContext = createContext(null);

export function CompanyProvider({ value, children }) {
  return <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>;
}

export function useCompany() {
  const ctx = useContext(CompanyContext);
  if (!ctx) throw new Error("useCompany must be used within CompanyProvider");
  return ctx;
}
